import React from 'react';
import styled from 'styled-components';
import { MenuIconIndex } from '../utility/MenuIconIndex';
import Icon from './Icon';

const IconSvg = styled.span`
    display: inline-flex;

    svg {
        width: 1em;
        height: 1em;
        fill: currentColor;
    }
`;

const MenuIcon = ({ icon, className, ...props }) => {
    const CustomIcon = MenuIconIndex[icon];
    if (!CustomIcon) return <Icon icon={icon} className={className} {...props} />;
    return (
        <IconSvg className={className}>
            <CustomIcon {...props} />
        </IconSvg>
    );
}

export default MenuIcon;
